import React, { useEffect } from 'react';
import { Row, Col, Card, Button } from 'antd';
import './dashboard.css';
import { Carousel } from 'antd';
import CourseList from '../courseList';
import { CaretRightOutlined } from '@ant-design/icons'
import {
  Link
} from "react-router-dom";
import { getChapters } from '../../actions/Guest-action';
import { action } from '../../store';
import { connect } from 'react-redux';
import { getCookie } from '../../utils/session';

const Dashboard = ({ chapters }) => {
  const onChange = (a, b, c) => {
    console.log(a, b, c);
  }
  const userId = getCookie("user_id");
  const gridStyle = {
    width: '50%',
    textAlign: 'center',
  };

  useEffect(() => {
    action(getChapters());
  }, []);

  return (
    <Row>
      <Col span={24}>
        <Carousel afterChange={onChange} autoplay>
          <div > <img src={require("../../img/glg/slide-1.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-2.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-3.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-4.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-5.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-6.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-7.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-8.jpg")} style={{ width: "100%" }} /></div>
          <div > <img src={require("../../img/glg/slide-9.jpg")} style={{ width: "100%" }} /></div>
        </Carousel>
      </Col>
      <Col span={24}>
        <Card style={{ textAlign: 'center', marginBottom: "10px" }} className="tab-mob-start">
            <Card.Grid style={{
              width: '100%',
              textAlign: 'center',
              backgroundColor: "#004c61"
            }} danger>
              <Link to={userId ? "/user" : "/start-learning/login"} style={{ color: "white", backgroundColor: "#004c61" }}>{userId ? "RESUME COURSE":"START LEARNING"}  <CaretRightOutlined /></Link>
            </Card.Grid>
          </Card>
        <Card className="guest-user-card" title="Over View" style={{ textAlign: 'center' }}>
          {
            (chapters || []).map((item, key) => (
              <Card.Grid key={key} style={gridStyle}>
                {item.Chapter}
              </Card.Grid>
            ))
          }
        </Card>
        
      </Col>
    </Row>
  )
}

const mapStateToProps = (state) => {
  const { GuestReducer } = state;
  return { chapters: GuestReducer.chapterList }
}

export default connect(mapStateToProps)(Dashboard);